/* PACKAGES */
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* ICONS */
import { IconArrowLeft } from "@tabler/icons-react";

/* ANIMATION */
import { animation } from "config/animation";

/* HEADER */
import Header from "layout/header";

const ThankYouPage = () => {
  /* SCROLL TO TOP */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Header />
      <motion.div variants={animation} className="py-16 xl:py-24 lg:py-24">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            {/* Check mark icon */}
            <div className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-8">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-12 h-12 text-green-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-4xl font-source font-bold uppercase text-black tracking-tight">
              Thank You for Contacting Us!
            </h1>

            <p className="text-xl font-source font-normal text-greyText mb-8">
              We&apos;ve received your message and appreciate your interest in
              our coaching consultation. Our team will review your inquiry and
              get back to you as soon as possible, typically within 24-48
              business hours.
            </p>

            <Link to="/">
              <Button className="shadow-none hover:shadow-none bg-black text-white border border-black px-6 py-3 rounded-full text-base font-source font-normal normal-case leading-none transition-all duration-500 ease-in-out flex items-center mx-auto">
                <IconArrowLeft className="w-5 h-5 mr-2" />
                Back to Homepage
              </Button>
            </Link>
          </div>
        </div>
      </motion.div>
    </React.Fragment>
  );
};

export default ThankYouPage;
